import React from "react"

import close from "./../../../UI/general/close.svg"
import quotation from "./../../../UI/quotation/quotation.svg"

interface Props {
    isQuotationModalOpened: boolean
    handleOpenQuotationModal: any
}

interface State {}

class QuotationModal extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isQuotationModalOpened ? "quotation-modal-container-opened":"quotation-modal-container-closed"}>
                <div className="close-quotation-btn">
                    <img src={close} alt="" onClick={() => {this.props.handleOpenQuotationModal()}}/>
                </div>
                <div className="quotation-img-container">
                    <img src={quotation} alt=""/>
                </div>
                <div className="quotation-title">
                    {"cotización".toUpperCase()}
                </div>
                <div className="quotation-text">
                    Llena los campos y recibirás en tu correo más información de los inmuebles.
                </div>
                <div className="quotation-input-container">
                    <div className="quotation-input-text">Nombre</div>
                    <input className="quotation-input" type={"text"}/>
                    <div className="quotation-input-text">Teléfono</div>
                    <input className="quotation-input" type={"number"}/>
                    <div className="quotation-input-text">Correo</div>
                    <input className="quotation-input" type={"email"}/>
                </div>
                <div className="quotation-selected-properties-container">
                    <div className="quotation-selected-properties-title">INMUEBLES SELECCIONADOS</div>
                    <div className="quotation-selected-properties-text">Puedes seleccionar un máximo de 5 inmuebles para cotizar.</div>
                    <div className="quotation-selected-individual-property"></div>
                    <div className="quotation-selected-individual-property"></div>
                    <div className="quotation-selected-individual-property"></div>
                    <div className="quotation-selected-individual-property"></div>
                    <div className="quotation-selected-individual-property"></div>
                </div>
                <div className="email-send-btn">
                    Enviar
                </div>
                <div className="quotation-email-copy">
                    Al presionar ENVIAR estoy aceptando los términos y condiciones en nuestra declaración de privacidad
                </div>
            </div>
        )
    }
}

export default QuotationModal